angular.module(NgAppName).component('crRecentSales', {
	templateUrl: 'crRecentSales.html',
	bindings: {
		rpc: '@',
		buildingType: '@',
		isNewDev: '<',
		graphId: '@',
		pageId: '@',
		onNoResults: '&'
	},
	controller: ['$element', '$window', '$timeout', '$scope', '$location', '$filter', '$q' ,'gVariables', 'PubSub', 'crResourcesService', 'StateService', function($element, $window, $timeout, $scope, $location, $filter, $q, gVariables, PubSub, crResourcesService, StateService) {
		var self = this;

		this.onMobile = true;
		this.loaded = false;
		this.firstLoad = true;
		this.hasData = false;
		this.recentSales = {};

		this.$onInit = () => {
			this.period = '';

			this.categoriesLabel = {
				10: 'Studios',
				11: '1 Beds',
				12: '2 Beds',
				13: '3 Beds',
				14: '4 Beds',
				15: '5 Beds',
				16: '6 Beds+'
			};

			this.loadAllData();

		};

		this.loadAllData = (period) => {
			let url = this.rpc + '&monthsBack=6';	
			let promise1 = crResourcesService.get(url).$promise;

			url = this.rpc + '&monthsBack=12';
			let promise2 = crResourcesService.get(url).$promise;

			url = this.rpc + '&monthsBack=24';
			let promise3 = crResourcesService.get(url).$promise;

			$timeout(() => {
				Promise.all([promise1, promise2, promise3])
				.then((values) => {

					this.recentSales['6'] = values[0];
					this.recentSales['12'] = values[1];
					this.recentSales['24'] = values[2];


					let hasSales6Months = false;
					let hasSales12Months = false;
					let hasSales24Months = false;
					Object.values(this.recentSales['6'].data).forEach(x => {if (x.sales && x.sales.length > 0) { hasSales6Months = true;}} );
					Object.values(this.recentSales['12'].data).forEach(x => {if (x.sales && x.sales.length > 0) { hasSales12Months = true;}} );
					Object.values(this.recentSales['24'].data).forEach(x => {if (x.sales && x.sales.length > 0) { hasSales24Months = true;}} );

					this.hasSales6Months = hasSales6Months;
					this.hasSales12Months = hasSales12Months;
					this.hasSales24Months = hasSales24Months;
	
					this.hasData = this.hasSales6Months || this.hasSales12Months || this.hasSales24Months;
	
					this.period = this.hasSales6Months ? '6' : '24';
					if (this.hasSales12Months) {
						this.period = '12';
					}
	
					if (this.hasData) {
						this.loadGraph(this.period);
					} else {
						this.onNoResults();
					}
	
					this.loaded = true; 
					if (this.firstLoad) {
						this.firstLoad = false;
					}
				})
				.catch((err) => {
					console.log(err);
				});
			});
			
		};

		this.loadGraph = (period) => {
			let recentSales = this.recentSales[period].data;

			let keys = Object.keys(recentSales).filter( x => x !== 'stats');
			this.valuesToKey = {};
			this.averageSales = [];
			for (let i = 0 ; i < keys.length; i++) {
				this.valuesToKey[keys.length - i] = keys[i];
			}

			let index = 0;
			let seriesLine = [];
			let seriesDots = [];
			angular.forEach(recentSales, (value, key) => {
				let serieLine = [];
				let serieDots = []
				if (value.beds) {
					let minSale = 0;
					let maxSale = 0;
					
					let labelAvg = 'Avg price of ';
					if (value.sales.length === 1) {
						labelAvg = 'Price of ';
					}
					this.averageSales.push({ 
						key,
						labelAvg,
						avgPrice: value.avg_price_format
					});
					let valuesSales = [];
					angular.forEach(value.sales, s => {
						valuesSales.push(parseInt(s.sale_price, 10));

						serieDots.push([parseInt(s.sale_price, 10) , keys.length - index]);
					});
					seriesDots.push(serieDots);

					if (valuesSales.length > 1) {
						serieLine = [
							[Math.min(...valuesSales), keys.length - index],
							[Math.max(...valuesSales), keys.length - index]
						];
						seriesLine.push(serieLine);
					}
					index++;
				}
			});

			this.generateGraph(seriesLine, seriesDots, keys, this.valuesToKey);
		};

		this.switchPeriod = (period) => {
			if (period !== this.period) {
				this.period = period;
				this.loadGraph(this.period);
			}
		};

		this.getSalesFromPoint = (point) => {
			let key = this.valuesToKey[point.y];
			let sales = this.recentSales[this.period].data[key].sales.filter(s => parseInt(s.sale_price, 10) === point.x);
			return sales; 
		};

		this.generateGraph = (lines, dots, keys, valuesToKey) => {
			let self = this;
			let linesGraph = [];
			let dotsGraph = [];
			for (let i = 0 ; i < lines.length; i++) {
				linesGraph.push({
					type: 'line',
					name: 'serie-' + i,
					color: '#D8EAFE',
					data: lines[i],
					linkedTo: 0,
					marker: {
						enabled: false
					},
					lineWidth: 22,
					enableMouseTracking: false
				}); 
			}

			for (let i = 0 ; i < dots.length; i++) {
				dotsGraph.push({
					name: 'serie-' + i,
					color: '#000',
					data: dots[i],
					linkedTo: 0,
					// yAxis: 1,
					marker: {
						symbol: 'square',
						width: 5,
						height: 20,
						radius: 10
					} 
				}); 
			}
			
			Highcharts.chart('container-' + this.graphId, {
				chart: {
					type: 'scatter',
					zoomType: 'xy',
					backgroundColor: '#f7f7f7'
				},
				title: {
					useHTML: true,
					text: ''
				},
				subtitle: {
					useHTML: true,
					text: ''
				},
			
				xAxis: {
					title: {
						enabled: false,
						text: ''
					},
					startOnTick: true,
					endOnTick: true,
					labels: {
						useHTML: true,
						allowOverlap: true,
						formatter: (data) => {
							let html = `$${$filter('shortNumberWithComma')(data.value, 2)}`;
							return html;
						}
					},
					gridLineColor: '#cccccc',
					gridLineWidth: 1
				},
				yAxis: [{
					title: {
						enabled: false,
						text: ''
					},
					reserveSpace: true,
					labels: {
						allowOverlap: true,
						reserveSpace: true,
						formatter: (data) => {
							let label = this.categoriesLabel[valuesToKey[data.value]];
							var html = '';
							html += `<div style="font-size: 13px">${label ? label : ''}</div>`;
							return html;
						}
					},
					gridLineWidth: 0		
				},
				{
					title: { 
						enabled: false,
						text: 'test'
					},
					reserveSpace: true,
					labels: {
						allowOverlap: true,
						reserveSpace: true,
						formatter: (data) => { 
							console.log(data);
							
							return 'test';
						}
					},
					gridLineWidth: 0,
					opposite: true
				}
			],

				tooltip: { 
					useHTML: true,
					outside: true,
					hideDelay: 1500,
					style: {
						pointerEvents: 'auto'
					}
				},
			
				plotOptions: {
					scatter: {
						marker: {
							radius: 5,
							states: {
								hover: {
									enabled: true,
									lineColor: 'rgb(100,100,100)'
								}
							}
						},
						states: {
							hover: {
								marker: {
									enabled: false
								}
							}
						},
						tooltip: {
							useHTML: true,
							headerFormat: '',
							backgroundColor: '#f7f7f7',
							pointFormatter: function(data) {
								let sales = self.getSalesFromPoint({x: this.x, y: this.y});
								let salesHtml = '<div class="sales-listing">';
								for (let i = 0; i < sales.length; i++) {
									let ppsqftHtml = sales[i].ppsqft_format ? `($${sales[i].ppsqft_format} / ft<sup>2</sup>)` : '';
									let saleHtml = `<div class='sale-listing'>
										<div class='apt-title' style='color: #008c99; font-weight: bold;'>
											<a href="${sales[i].url}" style="display: block;" rel="noopener" target="_blank"> Apt ${sales[i].unit}</a>
										</div>
										<div>${sales[i].beds}, ${sales[i].baths}${sales[i].ppsqft_format ? `, ${sales[i].sqft_format} sq ft` : ''}</div>
										<div>Sold for $${sales[i].sale_price_format} ${ppsqftHtml}</div>
										<div>Closed on ${sales[i].sale_date}</div>
									</div>`;
									salesHtml += saleHtml;
									if (sales.length > 1 && i < sales.length - 1) {
										salesHtml += '<br/>';
									}
								}
								salesHtml += '</div>';
								return salesHtml;
							}
						}
					}
				},
				legend: {
					enabled: false
				},
				series: [
					...linesGraph, ...dotsGraph
				],
				pointDescriptionFormatter: (data) => {
					console.log(data);
					let label = this.categoriesLabel[valuesToKey[data.value]];
					var html = '';
					html += `<div >${label ? label : ''}</div>`;
					return html;
				},

				credits: {
					enabled: false
				}
			});
			
		};



	}]
});
